import { serverHost } from '../config'

export class UrlSwitchService<UrlList extends Record<string, string>> {
  sourceUrl: string

  constructor(urlList: UrlList, role: keyof typeof urlList) {
    this.sourceUrl = serverHost + urlList[role] ?? ''
  }
}
